(function($) { 

    var search = {
        toggler: [],
        filters: {
            'event': '#search-event-filter',
            'post': '#search-article-filter',
            'hanke': '#search-hanke-filter',
            'network': '#search-network-filter',
            'theme': '#search-theme-filter'
        },

        updateFilter: function(selected){
            for (var key in this.filters) {
                if(key == selected){
                    $(this.filters[key]).removeClass('hide');
                }else{
                    $(this.filters[key]).addClass('hide');
                }
            }
        },

        updateToggler: function(){
            $.each(this.toggler, function(index, value){
                if (value.input.is(':checked') ){
                    value.container.removeClass("hide");
                } else{
                    value.container.find("input[type=checkbox]").attr("checked", false);
                    value.container.addClass("hide");
                }
            });
        },

        toggleSearchContainer: function(input,container){
            var $input = $(input);
            var $container = $(container);

            if ($input.prop("checked") == false){
                $container.addClass("hide");
            }
            this.toggler.push({"input": $input, "container": $container});
            $input.change(this.updateToggler.bind(this));
        },

        initHankeSelector: function(){
            $("#hanke-search-child-items").append( $(".checkbox-list__child > li") );

            $("#hanke-search-child-items > li").hide();
            $.each($("input:checked", "#hanke-search-child-items"), function(){
                var _parent = $(this).data("parent");
                $(".category-"+_parent, "#hanke-search-top").show();
            });
            $.each($("input:checked", ".category-parent-0"), function(){
                var _parent = $(this).val();
                $("#hanke-search-child-items").find(".category-parent-"+_parent).show();
            });          

            $("#hanke-search-top .category-parent-0 > input").change(function() {
                var _parent = $(this).val();
                $("#hanke-search-child-items").find(".category-parent-"+_parent).each(function(){
                    $(this).toggle();
                    $(this).find("input").attr("checked", false);
                })
            });
        },
        ajaxSearch: function(){
            $.get( '/', $("#search-form").serialize(), function( data ){
                // Place the fetched results inside the #content element
                $('#search-results').html( $(data).find('#search-results') );
                var count = $(data).find(".results-pagination .search-results-count .results-count strong:first").text();
                console.log(count);
                $('#title-result-count').text(count);
                //$('.search-results-count', '#search-results-top', '#title-result-count').html(count);
            });
        },
        openAdvancedSearch: function(){
            $(".advanced-search__open-filter").addClass("open");
            $(".advanced-search__expand").slideDown();
        },
        closeAdvancedSeach: function(){
            $(".advanced-search__open-filter").removeClass("open");
            $(".advanced-search__expand").slideUp();
        },
        toggleAdvancedSearch: function(){
            var _visible = $(".advanced-search__expand").is(":visible");
            if (_visible){
                search.closeAdvancedSeach();
            } else{
                search.openAdvancedSearch();
            }
        },
        hasFilters: function(){
            
            if ($("#search-form input[type=checkbox]").is(':checked')){
                $(".search-remove-filters").addClass("active");
            } else{
                $(".search-remove-filters").removeClass("active");
            }
        }
    };
	jQuery(document).on('click', '.mobile-search-tool-toggle, .toggle-mobile-search', function(e) {
		e.preventDefault();
		var navElement = jQuery('.search-page-sidebar');
		var navOpened = navElement.hasClass('is-active');

		if(navElement.length) {

			if(!navOpened) {
				navElement.addClass('is-active');
				jQuery(this).attr('aria-expanded', true);
				navElement.attr('aria-hidden', false);
				//add overlay
				jQuery('.js-off-canvas-overlay').addClass('is-visible is-closable');
				jQuery('.off-canvas-wrapper').css('position', 'fixed');
                search.openAdvancedSearch();

			} else {
				navElement.removeClass('is-active');
				navElement.attr('aria-hidden', true);
				jQuery(this).attr('aria-expanded', false);
				jQuery('.search-results-anchor').focus();
				jQuery('.js-off-canvas-overlay').removeClass('is-visible is-closable');
				jQuery('.off-canvas-wrapper').css('position', 'relative');

				//navElement.css('top', heroHeight);
			}

		}
    });

    $(".search-remove-filters").on("click", function(e){
        e.preventDefault();
        $("#search-form").find('input[type=checkbox]').prop("checked", false);
        $("#search-form").find('select').prop('selectedIndex',0);
        search.ajaxSearch();
        search.hasFilters();
        search.updateToggler();
    });
    
    $(".advanced-search__open-filter").click(function(e){
        e.preventDefault();
        search.toggleAdvancedSearch();
    })

    $(document).ready(function(){
        search.hasFilters();
        $("#search-form :input").not(".toggle").on( "change", function(){
            search.ajaxSearch();
            search.hasFilters();
        });
        if($('#hanke-search-child-items').length){

            $('#search-content-type-select').on('change', function(){
                search.updateFilter(this.value);
            });

            search.initHankeSelector();
            search.updateFilter($('#search-content-type-select').val());
           /*  search.toggleSearchContainer("#content-type--event", "#search-event-filter");
            search.toggleSearchContainer("#content-type--post", "#search-article-filter");
            search.toggleSearchContainer("#content-type--hanke", "#search-hanke-filter");
            search.toggleSearchContainer("#filter--network", "#search-network-filter");
            search.toggleSearchContainer("#filter--theme", "#search-theme-filter"); */


            $('.search_content_type').click(function() {
                $('.search_content_type').not(this).prop('checked', false);
                search.updateToggler();
            });
            $(".toggle").on("click", function(){
                if ($(this).attr("checked")){
                    search.openAdvancedSearch();
                }
                
            })
        }
    })
})( jQuery );